module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-203.9b0e15e.woff2";